import { useQuery, keepPreviousData } from '@tanstack/react-query';

import { formatListerData } from './selector';

import { useEnvironment } from '@/context/EnvironmentContext';
import { useLocale } from '@/context/LocaleContext';
import { productKeys, getProductList } from '@/services/product-list';

export const useProductList = (url: string) => {
  const { locale } = useLocale();
  const { environment } = useEnvironment();

  return useQuery({
    queryKey: productKeys.list(url, environment, locale),
    queryFn: () => getProductList({ resolvedUrl: url, environment, locale }),
    placeholderData: keepPreviousData,
    select: data => data && formatListerData(data),
  });
};
